<template>
  <div>
    <div v-if="!isPhone">
      <div class="table-container">
        <vab-query-form>
          <el-form ref="form" :model="queryForm" :inline="true" label-width="85px" @submit.native.prevent>
            <el-form-item label="用户编号">
              <el-input v-model="queryForm.user_code" placeholder="请输入用户编号" clearable
                @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="支付流水号">
              <el-input v-model="queryForm.pay_code" style="width: 220px" placeholder="请输入账号" clearable
                @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input v-model="queryForm.order_code" style="width: 220px" placeholder="请输入订单编号" clearable
                @keyup.enter.native="handleQuery" />
            </el-form-item>

            <el-form-item label="支付状态">
              <el-select v-model="value" clearable placeholder="请选择" @keyup.enter.native="handleQuery">
                <el-option v-for="item in options" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="完成状态">
              <el-select v-model="queryForm.order_service_status" clearable placeholder="请选择">
                <el-option label="已完成" :value="1"></el-option>
                <el-option label="未完成" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付时间">
              <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                @change="handleDateChange"></el-date-picker>
            </el-form-item>
            <el-form-item label="扫描编号">
              <el-input v-model="order_code" style="width: 220px" placeholder="请输入订单编号" clearable
                @keyup.enter.native="getOrder(order_code)" />
            </el-form-item>
            <el-form-item label="">
              <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
                查询
              </el-button>
              <el-button type="primary" @click="exportForm()">批量导出</el-button>
            </el-form-item>
          </el-form>
        </vab-query-form>
        <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
          :height="height" border @selection-change="setSelectRows">
          <el-table-column show-overflow-tooltip type="selection" width="55" align="center"></el-table-column>
          <el-table-column align="center" width="120" show-overflow-tooltip prop="nickname"
            label="用户昵称"></el-table-column>
          <el-table-column align="center" width="100" show-overflow-tooltip prop="user_code"
            label="用户编号"></el-table-column>
          <el-table-column align="center" width="80" show-overflow-tooltip prop="order_service_status" label="完成状态">
            <template #default="{ row }">
              <el-tag v-if="row.pay_service_status == 1" size="mini" type="success">
                已完成
              </el-tag>
              <el-tag v-else size="mini" type="danger">
                未完成
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" show-overflow-tooltip prop="storage_location"
            label="库位号"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="pay_code" label="支付流水号"
            width="200"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="order_code" label="订单编号"
            width="160"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="icb_code" label="ICB流水号"
            width="160"></el-table-column>
          <el-table-column show-overflow-tooltip prop="total_price" label="价格" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="status" label="支付状态" align="center">
            <template #default="{ row }">
              <el-tag v-if="row.status == 0" size="mini" type="danger">
                未支付
              </el-tag>
              <el-tag v-if="row.status == 1" size="mini" type="success">
                已支付
              </el-tag>
              <el-tag v-if="row.status == 2" size="mini" type="danger">
                已退款
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="goods_name" align="center" width="200"
            label="商品名称"></el-table-column>
          <el-table-column show-overflow-tooltip label="支付时间" prop="pay_time" width="160"
            align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120" align="center">
            <template #default="{ row }">
              <el-button type="text" native-type="submit" @click="seeInfo(row)">
                查看详情
              </el-button>

              <el-button v-if="row.status == 3" type="text" native-type="submit" @click="tui_pop(row)">
                退款
              </el-button>
              <el-button v-if="row.status == 1" type="text" native-type="submit" @click="tui_pop(row)">
                主动退款
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
          :page-sizes="[20, 50, 100, 200, 300, 400, 500]" :page-size="queryForm.limit" :total="total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
      </div>
    </div>
    <div v-if="isPhone" style="padding-top: 10px;">
      <!-- 手机端筛选 -->
      <el-form ref="form" :model="queryForm" :inline="true" label-width="85px" @submit.native.prevent>
        <el-form-item label="用户编号">
          <el-input v-model="queryForm.user_code" placeholder="请输入用户编号" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="queryForm.order_code" placeholder="请输入订单编号" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>

        <el-form-item label="支付状态">
          <el-select v-model="value" clearable placeholder="请选择" @keyup.enter.native="handleQuery">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成状态">
          <el-select v-model="queryForm.order_service_status" clearable placeholder="请选择">
            <el-option label="已完成" :value="1"></el-option>
            <el-option label="未完成" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="扫描编号">
          <el-input v-model="order_code" placeholder="请输入订单编号" clearable @keyup.enter.native="getOrder(order_code)" />
        </el-form-item>
        <el-form-item label="" style="display: flex; justify-content: flex-end;">
          <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <div v-for="(item, index) in list" :key="index" class="list_item">
        <div class="list_item_top" style="display: flex; align-items: center;">
          <span class="order_code" style="font-size: 14px; font-weight: 800;">订单编号：{{ item.order_code }}</span>
          <span class="order_code">{{ item.add_time }}</span>
        </div>
        <div>
          <div class="list_itme_center">
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">昵称:</div>
              <div class="list_itme_span">{{ item.nickname }}({{ item.user_code }})</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">价格:</div>
              <div class="list_itme_span">{{ item.total_price }}元</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">商品名:</div>
              <div class="list_itme_span">{{ item.goods_name }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">库位号:</div>
              <div class="list_itme_span">{{ item.storage_location ? item.storage_location : '暂无库位' }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">支付状态:</div>
              <div class="list_itme_span">
                <el-tag v-if="item.status == 0" size="mini" type="danger">
                  未支付
                </el-tag>
                <el-tag v-if="item.status == 1" size="mini" type="success">
                  已支付
                </el-tag>
                <el-tag v-if="item.status == 2" size="mini" type="danger">
                  已退款
                </el-tag>
              </div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">完成状态:</div>
              <div class="list_itme_span">
                <el-tag v-if="item.pay_service_status == 1" size="mini" type="success">
                  已完成
                </el-tag>
                <el-tag v-else size="mini" type="danger">
                  未完成
                </el-tag>
              </div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">支付时间:</div>
              <div class="list_itme_span">{{ item.pay_time }}</div>
            </div>
            <div class="list_btn_box">
              <el-button size="mini" native-type="submit" @click="seeInfo(item)">
                查看详情
              </el-button>
              <el-button type='danger' size="mini" native-type="submit" @click="tui_pop(item)">
                退款
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
        :page-sizes="[20, 50, 100, 200, 300, 400, 500]" :page-size="queryForm.limit" :total="total"
        @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="增值项详情" :width="isPhone ? '90vw' : '60vw'">
      <el-table v-if="!isPhone" ref="tableSort" :data="item_form_list" height="500px" border>
        <el-table-column show-overflow-tooltip prop="name" label="服务名*数量" align="center">
          <template #default="scope">
            {{ scope.row.name }} * {{ scope.row.num }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注" align="center"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="add_time" label="添加时间" align="center"> </el-table-column>
        <el-table-column label="图片" align="center">
          <template #default="scope">
            <!-- PC端 -->
            <uploadFile v-if="scope.row.service_type == 1 || scope.row.service_type == 2" :limit="100"
              :img-list-string="scope.row.pic" :is-phone="false" :row-index="scope.$index"
              @fileChange="skuListPicChange($event, scope.$index)" @editImage="handleEditImage" />
          </template>
        </el-table-column>
        <el-table-column label="视频" align="center">
          <template #default="scope">
            <uploadvideo v-if="scope.row.service_type == 2" :img-list-string="scope.row.video"
              @fileChange="video_change($event, scope.$index)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="scope">
            <div>
              <el-switch v-model="scope.row.tick" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="isPhone" style="height: 50vh; overflow-y: auto;">
        <div v-for="(item, index) in item_form_list" :key="index" class="pop_item">
          <div class="list_itme_span_th">
            <div class="list_itme_center_title">服务名:</div>
            <div class="list_itme_span">
              {{ item.name }} * {{ item.num }}
            </div>
          </div>
          <div class="list_itme_span_th">
            <div class="list_itme_center_title">备注:</div>
            <div class="list_itme_span">
              {{ item.remark }}
            </div>
          </div>
          <div v-if="item.service_type == 1 || item.service_type == 2" class="list_itme_span_th">
            <div class="list_itme_center_title">拍照:</div>
            <div class="list_itme_span">
              <!-- 手机端 -->
              <uploadFile :limit="100" :img-list-string="item.pic" :is-phone="true" :row-index="index"
                @fileChange="skuListPicChange($event, index)" @editImage="handleEditImage" />
            </div>
          </div>
          <div v-if="item.service_type == 2" class="list_itme_span_th">
            <div class="list_itme_center_title">视频:</div>
            <div class="list_itme_span">
              <uploadvideo :img-list-string="item.video" @fileChange="video_change($event, index)" />
            </div>
          </div>
          <div class="list_itme_span_th">
            <div class="list_itme_center_title">操作:</div>
            <div class="list_itme_span">
              <el-switch v-model="item.tick" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片编辑器弹窗 -->
    <el-dialog :visible.sync="editorVisible" title="编辑图片" :fullscreen="isPhone" :width="isPhone ? '100%' : '80vw'"
      :close-on-click-modal="false" @close="closeEditor">
      <div class="editor-container">
        <!-- 将 @mousemove="drawing" 改为 @mousemove="onDrawing" -->
        <canvas ref="editorCanvas" :width="canvasWidth" :height="canvasHeight" @touchstart="startDrawing"
          @touchmove="onDrawing" @touchend="endDrawing" @mousedown="startDrawing" @mousemove="onDrawing"
          @mouseup="endDrawing" @mouseleave="endDrawing" style="touch-action: none;">
        </canvas>

        <!-- 工具栏 -->
        <div class="toolbar">
          <el-button-group>
            <el-button size="small" :type="tool === 'pen' ? 'primary' : 'default'" @click="tool = 'pen'">
              画笔
            </el-button>
            <el-button size="small" :type="tool === 'text' ? 'primary' : 'default'" @click="addText">
              文字
            </el-button>
            <el-button size="small" @click="undoEditor">撤销</el-button>
            <el-button size="small" @click="clearCanvas">清空</el-button>
          </el-button-group>

          <div class="color-picker">
            <span>颜色：</span>
            <input type="color" v-model="penColor">
          </div>

          <div class="stroke-width">
            <span>粗细：</span>
            <input type="range" min="2" max="20" v-model="penWidth">
          </div>
        </div>
      </div>

      <div slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEditedImage">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible_tui" title="退款" width="80vw">
      <el-form ref="form" :model="queryForm" label-width="85px" @submit.native.prevent>
        <el-form-item label="订单总金额">
          <el-input v-model="tui_info.total_price" style="width: 140px" disabled />
        </el-form-item>
        <el-form-item label="退款现金">
          <el-input v-model="tui_info.price" style="width: 140px" disabled />
        </el-form-item>
        <el-form-item label="退款余额">
          <el-input v-model="tui_info.service_balance" style="width: 140px" disabled />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input v-model="tui_info.application_refund_remark" placeholder="退款原因" style="width: 140px" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_tui = false">取消</el-button>
        <el-button type="primary" :loading="tui_loading" @click="tuiKuan">确认退款</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderServiceServiceList,
  oexcelOutPay,
  OrderService_detail,
  OrderService_file_add,
  OrderService_update,
  service_update,
  order_service_excel_out,
  service_refund,
  application_refund_part
} from '@/api/xgcApi'
import {
  baseURL_print,
  getUploadUrl
} from '@/config'
import uploadFile from '@/components/uploadimg_small'
import uploadvideo from '@/components/uploadvideo'
import exoprt_file from '@/utils/expor_file'
export default {
  name: 'ManagePay',
  components: {
    uploadFile,
    uploadvideo
  },
  data() {
    return {
      isPhone: false,
      tui_loading: false,
      dialogVisible_tui: false,
      tui_info: {},
      order_code: null,
      chooseId: null,
      dialogVisible: false,
      item_form_list: [],
      height: '75vh',
      pay_id: '',
      uploadFileUrl: 'index/index/file',
      list: [],
      background: true,
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      elementLoadingText: '正在加载...',
      queryForm: {
        'page': 1,
        'limit': 20,
        "pay_code": "",
        "user_code": "",
        "order_express_code": "",
        "order_code": "",
        "status": "1",
        "start_time": "",
        "end_time": "",
        'order_service_status': "",
        'kor_type': 0
      },
      value: '1',
      value1: '',
      options: [{
        value: '1',
        label: '已支付',
      },
      {
        value: '3',
        label: '退款中',
      }],
      time: '',
      // 图片编辑器相关数据
      editorVisible: false,
      editingImageUrl: '',
      editingImageInfo: {
        rowIndex: null,
        imgIndex: null
      },
      canvasWidth: 0,
      canvasHeight: 0,
      originalImage: null,
      ctx: null,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      tool: 'pen',
      penColor: '#ff0000',
      penWidth: 5,
      history: []
    }
  },
  created() {
    this.fetchData()
    this.isPhone = this.isMobile()
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'windows phone'];
      var isModul = mobileKeywords.some(keyword => userAgent.includes(keyword))
      return isModul
    },
    // 处理图片编辑
    handleEditImage({ imageUrl, rowIndex, imgIndex }) {
      console.log('编辑图片', imageUrl)
      this.editingImageUrl = imageUrl
      this.editingImageInfo = { rowIndex, imgIndex }
      this.editorVisible = true

      // 使用 setTimeout 确保 DOM 完全渲染
      setTimeout(() => {
        this.$nextTick(() => {
          this.initEditorCanvas()
        })
      }, 100)
    },
    // // 初始化编辑器画布
    // initEditorCanvas() {
    //   const img = new Image()
    //   img.crossOrigin = 'Anonymous'
    //   img.src = this.editingImageUrl

    //   img.onload = () => {
    //     const canvas = this.$refs.editorCanvas
    //     // 限制最大宽度
    //     const maxWidth = this.isPhone ? window.innerWidth - 80 : 600
    //     const scale = maxWidth / img.width
    //     this.canvasWidth = img.width * scale
    //     this.canvasHeight = img.height * scale

    //     canvas.width = this.canvasWidth
    //     canvas.height = this.canvasHeight
    //     canvas.style.width = `${this.canvasWidth}px`
    //     canvas.style.height = `${this.canvasHeight}px`

    //     this.ctx = canvas.getContext('2d')
    //     this.ctx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight)

    //     // 保存原始图像
    //     this.originalImage = this.ctx.getImageData(0, 0, this.canvasWidth, this.canvasHeight)
    //     this.saveToHistory()
    //   }
    // },
    // 初始化编辑器画布
    // 初始化编辑器画布 - 使用原始尺寸
    initEditorCanvas() {
      const canvas = this.$refs.editorCanvas

      if (!canvas) {
        console.error('canvas 元素不存在')
        return
      }

      const img = new Image()
      img.crossOrigin = 'Anonymous'
      img.src = this.editingImageUrl

      let timeout = setTimeout(() => {
        if (!img.complete) {
          this.$message.error('图片加载超时')
          this.editorVisible = false
        }
      }, 10000)

      img.onload = () => {
        clearTimeout(timeout)

        // 使用图片原始尺寸，不进行压缩
        this.canvasWidth = img.width
        this.canvasHeight = img.height

        // 设置画布尺寸为原始尺寸
        canvas.width = this.canvasWidth
        canvas.height = this.canvasHeight

        // 使用CSS控制显示大小，保持比例适应屏幕
        const maxWidth = this.isPhone ? window.innerWidth - 40 : 800
        const maxHeight = this.isPhone ? window.innerHeight - 300 : 600

        let displayWidth = this.canvasWidth
        let displayHeight = this.canvasHeight

        // 如果图片太大，按比例缩小显示，但不影响实际像素
        if (displayWidth > maxWidth) {
          const ratio = maxWidth / displayWidth
          displayWidth = maxWidth
          displayHeight = displayHeight * ratio
        }
        if (displayHeight > maxHeight) {
          const ratio = maxHeight / displayHeight
          displayHeight = maxHeight
          displayWidth = displayWidth * ratio
        }

        canvas.style.width = `${displayWidth}px`
        canvas.style.height = `${displayHeight}px`

        this.ctx = canvas.getContext('2d', { willReadFrequently: true })
        // 绘制原始尺寸的图片
        this.ctx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight)

        // 保存原始图像
        this.originalImage = this.ctx.getImageData(0, 0, this.canvasWidth, this.canvasHeight)
        this.saveToHistory()
      }

      img.onerror = () => {
        clearTimeout(timeout)
        console.error('图片加载失败')
        this.$message.error('图片加载失败，请检查图片地址')
        this.editorVisible = false
      }
    },

    // 获取画布坐标
    // 获取画布坐标 - 修正坐标系
    getCanvasCoordinates(e) {
      const canvas = this.$refs.editorCanvas
      const rect = canvas.getBoundingClientRect()

      // 注意：现在 canvas.width 是原始尺寸，rect.width 是CSS显示尺寸
      const scaleX = canvas.width / rect.width
      const scaleY = canvas.height / rect.height

      let clientX, clientY
      if (e.touches) {
        clientX = e.touches[0].clientX
        clientY = e.touches[0].clientY
      } else {
        clientX = e.clientX
        clientY = e.clientY
      }

      let x = (clientX - rect.left) * scaleX
      let y = (clientY - rect.top) * scaleY

      x = Math.max(0, Math.min(x, canvas.width))
      y = Math.max(0, Math.min(y, canvas.height))

      return { x, y }
    },
    // 开始绘制
    startDrawing(e) {
      e.preventDefault()
      this.isDrawing = true
      const pos = this.getCanvasCoordinates(e)
      this.lastX = pos.x
      this.lastY = pos.y

      if (this.tool === 'pen') {
        this.ctx.beginPath()
        this.ctx.moveTo(this.lastX, this.lastY)
        this.ctx.lineTo(this.lastX, this.lastY)
        this.ctx.stroke()
      }
    },
    // 绘制中
    onDrawing(e) {
      if (!this.isDrawing) return
      e.preventDefault()

      const pos = this.getCanvasCoordinates(e)
      const currentX = pos.x
      const currentY = pos.y

      if (this.tool === 'pen') {
        this.ctx.strokeStyle = this.penColor
        this.ctx.lineWidth = this.penWidth
        this.ctx.lineCap = 'round'
        this.ctx.lineJoin = 'round'

        this.ctx.beginPath()
        this.ctx.moveTo(this.lastX, this.lastY)
        this.ctx.lineTo(currentX, currentY)
        this.ctx.stroke()
      }

      this.lastX = currentX
      this.lastY = currentY
    },
    // 结束绘制
    endDrawing() {
      if (this.isDrawing) {
        this.isDrawing = false
        this.saveToHistory()
      }
    },
    // 添加文字
    addText() {
      const text = prompt('请输入文字：', '')
      if (text && text.trim()) {
        const centerX = this.canvasWidth / 2
        const centerY = this.canvasHeight / 2

        this.ctx.font = `${this.penWidth * 4}px "Microsoft YaHei"`
        this.ctx.fillStyle = this.penColor
        this.ctx.textAlign = 'center'
        this.ctx.fillText(text, centerX, centerY)

        this.saveToHistory()
      }
    },
    // 撤销
    undoEditor() {
      if (this.history.length > 1) {
        this.history.pop()
        const prevState = this.history[this.history.length - 1]
        this.ctx.putImageData(prevState, 0, 0)
      } else if (this.history.length === 1) {
        this.ctx.putImageData(this.originalImage, 0, 0)
      }
    },
    // 清空画布
    clearCanvas() {
      this.ctx.putImageData(this.originalImage, 0, 0)
      this.saveToHistory()
    },
    // 保存到历史记录
    saveToHistory() {
      this.history.push(this.ctx.getImageData(0, 0, this.canvasWidth, this.canvasHeight))
      if (this.history.length > 20) {
        this.history.shift()
      }
    },
    // 保存编辑后的图片
    async saveEditedImage() {
      const base64Image = this.$refs.editorCanvas.toDataURL('image/png')
      const { rowIndex, imgIndex } = this.editingImageInfo
      const item = this.item_form_list[rowIndex]

      let picList = []
      if (typeof item.pic === 'string') {
        picList = item.pic ? item.pic.split(',') : []
      } else {
        picList = [...(item.pic || [])]
      }

      // 替换编辑的图片为 base64
      picList[imgIndex] = base64Image

      // 更新显示
      this.$set(this.item_form_list[rowIndex], 'pic', picList)

      // 上传到服务器
      await this.uploadEditedImage(base64Image, rowIndex, imgIndex)

      this.editorVisible = false
      this.$message.success('图片编辑保存成功')
    },
    // 上传编辑后的图片
    async uploadEditedImage(base64Image, rowIndex, imgIndex) {




      const file = this.dataURLtoFile(base64Image, `edited_${Date.now()}.png`)
      const formData = new FormData()
      formData.append('file', file)






      try {
        console.log(file, 'wenjia')
        var data = {
          file: file,
        }

        exoprt_file(this.uploadFileUrl, data).then((res) => {

          console.log('上传文件', data)

          // this.imgList = [...this.imgList, { url: getUploadUrl + res }]
          // this.loading = false
          // this.emitChange()

          console.log(res)
          const picList = [...this.item_form_list[rowIndex].pic]

          console.log(picList, 'picList123')

          picList[imgIndex] = getUploadUrl + res
          this.$set(this.item_form_list[rowIndex], 'pic', picList)
          console.log(this.item_form_list[rowIndex], 'item_form_list[rowIndex]')
          // 同时调用更新接口
          this.updateChagne(this.item_form_list[rowIndex])
          this.item_form_list[rowIndex].tick = true
        }).catch(() => {
          this.loading = false
          this.$message.error('上传失败')
        })
        // 这里需要调用您的上传接口
        // const res = await uploadImage(formData)
        // 如果上传接口返回 URL，则替换
        // const picList = [...this.item_form_list[rowIndex].pic]
        // picList[imgIndex] = res.data.url
        // this.$set(this.item_form_list[rowIndex], 'pic', picList)

      } catch (error) {
        console.error('上传失败', error)
      }
    },
    // base64 转 File
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    // 关闭编辑器
    closeEditor() {
      this.history = []
      this.editingImageUrl = ''
    },
    tui_pop(row) {

      console.log(row.status, '11111')

      this.dialogVisible_tui = true
      this.tui_info = row
      this.tui_info.application_refund_remark = row.order_apply_refund?.[0]?.apply_reason || '';
    },
    tuiKuan() {
      this.tui_loading = true
      var data = {}
      // 用户申请退款
      if (this.tui_info.status == 3) {
        data = {
          "id": this.tui_info.id,
          "price": this.tui_info.price,
          "type": 7,
          "refund_remarks": ""
        }
        service_refund(data).then(res => {
          this.$message({
            type: 'success',
            message: '退款成功!'
          });
          this.tui_loading = false
          this.fetchData()
          this.dialogVisible_tui = false
        }).catch(err => {
          this.tui_loading = false
        })
      } else if (this.tui_info.status == 1) { //主动退款
        data = {
          "id": this.tui_info.id,
          "price": this.tui_info.price,
          "type": 4, //0包裹 1代买 2代付 3商品 4增值服务
          "apply_reason": ""
        }
        application_refund_part(data).then(res => {
          this.$message({
            type: 'success',
            message: '主动退款成功!'
          });
          this.tui_loading = false
          this.fetchData()
          this.dialogVisible_tui = false
        }).catch(err => {
          this.tui_loading = false
        })
      }




    },
    getOrder(code) {
      OrderService_detail({
        order_code: code
      }).then(res => {


        this.dialogVisible = true
        this.item_form_list = res.data
        this.order_code = null
      })
    },
    video_change(e, index) {
      this.item_form_list[index].video = e[0]
      this.updateChagne(this.item_form_list[index])
      this.item_form_list[index].tick = true
    },
    updateChagne(item) {
      console.log(item, '55555')
      console.log(item.pic, '更新图片传值')



      var data = {
        "order_service_id": item.id,
        "pic": Array.isArray(item.pic) ? item.pic.join(',') : (item.pic || ''),
        "video": item.video
      }
      OrderService_file_add(data).then(res => { })
    },
    skuListPicChange(e, index) {
      console.log(e, index, '-------')
      this.item_form_list[index].pic = e.join(',')
      this.updateChagne(this.item_form_list[index])
      this.item_form_list[index].tick = true
    },
    save() {
      var arr = []
      this.item_form_list.forEach((item, index) => {
        if (item.tick == true) {
          arr.push(item.id)
        }
      })
      var data = {
        pay_id: this.pay_id,
        order_id: this.chooseId,
        order_service_id: arr.join(',')
      }
      service_update(data).then(res => {
        this.$message({
          type: "success",
          message: '操作成功!'
        })
        this.dialogVisible = false
        this.fetchData()
      })
    },
    handleEdit1(index, row) {
      payUpdate(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
        this.fetchData()
      })
    },
    seeInfo(row) {
      this.chooseId = row.order_id
      this.pay_id = row.id
      OrderService_detail({
        pay_id: row.id,
        order_id: row.order_id
      }).then(res => {
        this.dialogVisible = true
        this.item_form_list = res.data
      })
    },
    handleDateChange(value) {
      if (value != null) {
        this.queryForm.start_time = value[0]
        this.queryForm.end_time = value[1]
      } else {
        this.queryForm.start_time = ''
        this.queryForm.end_time = ''
      }
    },
    exportForm() {
      if (this.selectRows.length > 0) {
        this.$baseConfirm('确定导出已选', null, async () => {
          const ids = this.selectRows.map((item) => item.id).join()
          const { data } = await order_service_excel_out({
            id: ids,
          })
          const fileUrl = getUploadUrl + data
          window.open(fileUrl)
          this.$message({
            type: 'success',
            message: '导出成功',
          })
        })
      } else {
        this.$baseMessage('未选中任何行', 'error')
        return false
      }
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    handleQuery() {
      this.queryForm.page = 1
      this.queryForm.status = this.value
      this.queryForm.type = this.value1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      var data = {
        ...this.queryForm
      }
      orderServiceServiceList(data).then((res) => {
        const { data } = res
        this.list = data.list
        this.total = data.count
        this.listLoading = false
      })
    },
  },
}
</script>

<style scoped>
@import url(./value_add_serveie.css);

:deep .right-panel {
  display: flex;
  align-items: center;
}

:deep .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

/* 图片编辑器样式 */
.editor-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.editor-container canvas {
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: crosshair;
  max-width: 100%;
  height: auto;
  touch-action: none;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 8px;
}

.color-picker,
.stroke-width {
  display: flex;
  align-items: center;
  gap: 5px;
}

.stroke-width input {
  width: 100px;
}
</style>